



















































































import BankImg from '@/components/image/BankImg.vue'
import Translation from '@/mixins/Translation'
import BttPopup from '@/components/popup/btt/BttPopup.vue'
import FooterButton from '@/components/popup/btt/FooterButton.vue'
import toErrorMessage from '@/filters/to-error-message'
import {Form, FormItem, Input} from 'element-ui'
import {mask} from 'vue-the-mask'
import {Component, Mixins, Watch, Prop, Ref} from 'vue-property-decorator'
import {namespace} from 'vuex-class'

const banks = namespace('banks')
const layout = namespace('layout')
const clients = namespace('clients')
const invoices = namespace('invoices')
const userAgent = namespace('userAgent')

interface Errors {
  number: boolean
  owner: boolean
}

@Component({
  components: {
    BankImg,
    BttPopup,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Input.name]: Input,
    FooterButton,
  },
  methods: {toErrorMessage},
  directives: {mask},
})
export default class ClientAccountFormPopup extends Mixins(Translation) {
  @banks.Action('getOwner') getOwner
  @banks.State('owner') owner
  @banks.State('selectedBankCode') selectedBankCode
  @banks.Mutation('updateOwner') updateOwner
  @banks.Mutation('clearBankCode') clearBankCode
  @layout.Mutation('updateError') updateError
  @layout.Mutation('updateToast') updateToast
  @clients.State('clientAccounts') clientAccounts
  @clients.State('selectedAccount') selectedAccount
  @clients.Action('createClientAccount') createClientAccount
  @invoices.Action('updateInvoice') updateInvoice
  @userAgent.State('isKakaoBrowser') isKakaoBrowser
  @userAgent.Getter('isIOS') isIOS

  @Prop({default: 'components.popup.client-account'}) translation: string
  @Prop({default: false}) isOpen: boolean
  @Prop({default: false, type: Boolean}) value: boolean
  @Prop({default: () => ({}), type: Object}) invoiceInfo
  @Prop({default: 'update', type: String}) type: 'create' | 'update'

  @Ref('accountInput') readonly accountInput: Input

  errors: Errors = {
    number: true,
    owner: true,
  }

  bankCode: string = ''
  number: string = ''
  invoiceClientSummary: string = ''
  invoiceBizSummary: string = ''
  getOwnerStatus: string = 'pending'
  open: boolean = true
  isFocusedInput: boolean = false
  createError: string = ''

  get contentWrapStyle() {
    /**
     * TODO: fix
     * iOS 카카오 인앱브라우저에서 popup 안에 input focus 시 input이 키보드에 가려지는 오류 임시 fix
     * only kakao browser style
     */
    return {
      'margin-bottom': this.isFocusedInput && this.isKakaoBrowser && this.isIOS ? '200px' : ''
    }
  }

  get accountInputError() {
    return this.ownerError || toErrorMessage(this.createError)
  }

  get ownerError() {
    if(this.number === '') {
      return this.ts('verification.required.number')
    } else if(this.getOwnerStatus === 'failed') {
      return this.ts('verification.failed.owner')
    } else if(this.getOwnerStatus === 'pending') {
      return this.ts('verification.required.owner')
    }
    return ''
  }

  get bizSummaryError() {
    if(this.invoiceClientSummary.length > 7) {
      return this.ts('verification.max-length')
    }
    return ''
  }

  get clientSummaryError() {
    if(this.invoiceBizSummary.length > 7) {
      return this.ts('verification.max-length')
    }
    return ''
  }

  get isOwnerVisible(): boolean {
    return Boolean(this.owner && !this.createError && this.getOwnerStatus === 'success')
  }

  get rules() {
    const {ts} = this
    return {
      number: [
        {
          required: true,
          type: 'string',
          message: ts('verification.required.number'),
          trigger: 'change',
        },
        {
          validator: (_, value, callback) => {
            let callbackResult = undefined as any
            if(this.getOwnerStatus === 'failed') {
              callbackResult = new Error(ts('verification.failed.owner') as any)
            }
            return callback(callbackResult)

          },
          trigger: ['change', 'blur'],
        },
        {
          validator: (_, value, callback) => {
            let callbackResult = undefined as any
            if(!this.owner) {
              callbackResult = new Error(ts('verification.required.owner') as any)
            }
            return callback(callbackResult)

          },
          trigger: [''],
        },
      ],
      owner: [
        {
          required: true,
          type: 'string',
          message: ts('verification.required.owner'),
          trigger: 'change',
        },
      ],
    }
  }

  @Watch('value', {immediate: true})
  __value(value) {
    const {invoiceInfo} = this
    this.open = value
    if(value) {
      this.invoiceBizSummary = invoiceInfo.bizSummary || ''
      this.invoiceClientSummary = invoiceInfo.clientSummary || ''

      if(this.selectedBankCode) {
        this.$nextTick(() => {
          this.accountInput?.focus()
        })
      }
    } else {
      this.resetFormData()
    }
  }

  @Watch('number')
  __number(val) {
    if(val) {
      this.getOwnerStatus = 'pending'
      this.updateOwner('')
      this.createError = ''
    }
  }

  @Watch('selectedBankCode', {immediate: true})
  __selectedBankCode(val) {
    this.bankCode = val
  }

  onClosePopup() {
    this.onHandlePopup(false)
  }

  onClickBankImg() {
    this.$emit('open-code-select-popup')
    this.onClosePopup()
  }

  onValidate(field, value) {
    this.errors[field] = !value
    this.errors = {...this.errors}
  }

  searchOwner() {
    if(!this.number || this.getOwnerStatus === 'loading') {
      return
    }
    this.getOwnerStatus = 'loading'
    this.getOwner({
      bankCode: this.bankCode,
      number: this.number,
    })
      .then(() => {
        if(!this.owner) {
          this.getOwnerStatus = 'failed'
        } else {
          this.getOwnerStatus = 'success'
        }
      })
      .catch((error) => {
        this.getOwnerStatus = 'pending'
        this.updateError({
          id: 'get-owner',
          message: this.ts('error.owner'),
        })
        throw error
      })
  }

  onClickConfirm() {
    const form = this.$refs.form as any
    form.validateField('number')

    const {invoiceInfo, ts, updateError} = this
    const isAddBank = Boolean(this.type === 'create')
    if(isAddBank) {
      if(this.owner === '' || this.bankCode === '' || this.number === '' || this.getOwnerStatus !== 'success') {
        return false
      }
      const submitData = {
        id: invoiceInfo.clientId,
        bank: this.bankCode,
        owner: this.owner,
        number: this.number,
      }
      this.createClientAccount(submitData)
        .then(async () => {
          const clientName = this.invoiceInfo?.clientName
          this.updateToast({
            id: 'create-client-account',
            message: `${clientName}의 ${ts('account')}가 ${ts('register')}되었습니다.`
          })
          await this.updateSummary(isAddBank)
        })
        .catch((error) => {
          const [errorCode] = error?.response?.data?.number || []
          this.createError = errorCode
          if(errorCode !== 'ALREADY_EXISTS' && errorCode !== 'MY_BIZ_BANK_ACCOUNT') {
            updateError({
              id: 'create-client-accounts',
              message: ts('error.account'),
            })
          }

          this.$sentry.withScope((scope) => {
            scope.setExtra('submitData', submitData)
            scope.setExtra('error', error?.response)
            this.$sentry.captureException(error)
          })
        })
    } else {
      this.updateSummary(false)
    }
  }
  updateSummary(isAddBank) {
    const {invoiceInfo} = this
    const data = {
      id: invoiceInfo.id,
      bizSummary: this.invoiceBizSummary,
      clientSummary: this.invoiceClientSummary,
      clientBankAccount: isAddBank ? this.clientAccounts[0].id :this.selectedAccount.id,
    }
    this.updateInvoice(data)
      .then((response) => {
        this.$emit('complete', response)
        this.onClosePopup()
      })
      .catch((error) => {
        this.updateError({
          id: 'get-client-accounts',
          message: this.ts('error.summary'),
        })
        throw error
      })
  }

  onHandleFocus(event, inputName) {
    if(inputName === 'account-input' && !this.bankCode) {
      event?.target?.blur?.()
      this.onClickBankImg()
    } else if(this.isKakaoBrowser && this.isIOS) {
      this.isFocusedInput = true
      const target = event?.target
      if(target) {
        this.$nextTick(() => {
          target.scrollIntoView()
        })
      }
    }
  }

  onHandleBlur() {
    this.isFocusedInput = false
  }

  onHandlePopup(value) {
    this.$emit('input', value)
  }

  resetFormData() {
    this.number = ''
    this.clearBankCode()
    this.invoiceBizSummary = ''
    this.invoiceClientSummary = ''
    this.updateOwner('')
    this.createError = ''
  }
}
